(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frame-video-animation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const fvaVideo = document.querySelectorAll('.fva-section .fva-video-wrapper');
    let fvaTargetVideo = null;
    for (const i of fvaVideo) {
      if (window.getComputedStyle(i).display == 'block') {
        fvaTargetVideo = i.querySelector('video-media video');
      }
    }
    if (fvaTargetVideo) {

      let fvaLastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      let fvaScrollTimeout;
      let fvaScrollDirection = null; // 'up' 或 'down'
      let fvaFrameNumber; // 当前帧数

      let fvaFirstByteTime = 1
      if (document.querySelector('.fva-section .fva-first-time').value) {
        fvaFirstByteTime = Number(document.querySelector('.fva-section .fva-first-time').value);
      }

      window.addEventListener('scroll', () => {
        clearTimeout(fvaScrollTimeout); // 清除之前的定时器
        // 获取当前滚动位置
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        // 判断滚动方向
        if (currentScrollPosition > fvaLastScrollPosition) {
          fvaScrollDirection = 'down';
        } else {
          fvaScrollDirection = 'up';
        }
        fvaLastScrollPosition = currentScrollPosition; // 更新最后滚动位置
        // 设置新的定时器
        fvaScrollTimeout = setTimeout(function () {
          const rect = fvaTargetVideo.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const videoCenter = (rect.top + rect.bottom) / 2;
          // 检测视频位于窗口中
          if (videoCenter >= 0 && videoCenter <= windowHeight) {
            // 视频在屏幕内
            if (fvaScrollDirection === 'down') {
              if(fvaTargetVideo.paused) {
                fvaTargetVideo.play();
              }
            }
            if (fvaScrollDirection === 'up') {
              fvaTargetVideo.pause()
              if (fvaTargetVideo.currentTime > 0 && fvaTargetVideo.currentTime < fvaFirstByteTime) {
                fvaTargetVideo.currentTime = 0
              }
              if (fvaTargetVideo.currentTime > fvaFirstByteTime && fvaTargetVideo.currentTime < fvaTargetVideo.duration) {
                fvaTargetVideo.currentTime = fvaFirstByteTime
              }
            }
          }
          favHandleFrameNumber(fvaFrameNumber, fvaTargetVideo);
        }, 100);
      });

      fvaTargetVideo.addEventListener('timeupdate', function () {
            let fvaVideoTime = fvaTargetVideo.currentTime;
            if(fvaVideoTime == 0) {
              fvaFrameNumber = 0;
            } else if (fvaVideoTime>0 && fvaVideoTime < fvaFirstByteTime) {
                // 起始
                fvaFrameNumber = 1;
            } else if (fvaVideoTime == fvaFirstByteTime) {
                // 第一帧
                fvaFrameNumber = 2;
            }else if (fvaVideoTime > fvaFirstByteTime && fvaVideoTime < fvaTargetVideo.duration) {
                // 第二帧
                fvaFrameNumber = 3;
            } else if (fvaVideoTime ==  fvaTargetVideo.duration) {
                // 第三帧
                fvaFrameNumber = 4;
            }
            favHandleFrameNumber(fvaFrameNumber, fvaTargetVideo);
        });
    }
  });

  function favHandleFrameNumber(frameNumber, fvaTargetVideo) {
    const fvaTopText = fvaTargetVideo.closest('.shopify-section--frame-video-animation').querySelectorAll('.fva-top-wrapper .fva-top-text');
    switch (frameNumber) {

      case 0:
        // 0s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;
      case 1:
        // 0-1s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 1;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;

      case 2:
        // 1s
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 1;
        fvaTopText[2].style.opacity = 0;
        fvaTopText[1].style.height = 48 + 'px';
        fvaTopText[2].style.height = 0;
        break;

      case 3:
        // 1-播放结束
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 1;
        fvaTopText[1].style.height = 0;
        fvaTopText[2].style.height = 48 + 'px';
        break;

      case 4:
        // 播放结束
        fvaTopText[0].style.opacity = 1;
        fvaTopText[1].style.opacity = 0;
        fvaTopText[2].style.opacity = 1;
        fvaTopText[1].style.height = 0;
        fvaTopText[2].style.height = 48 + 'px';
        break;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-adventure"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wb-adventure')) {
  customElements.define('wb-adventure', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const controller = new AbortController();
      this.cleanup = () => {
        controller.abort();
        this.querySelectorAll('video').forEach(video => video.pause());
      };
      const options = { signal: controller.signal };
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const startVideo = (panel) => {
        const video = panel.querySelector('video');
        if (!video || panel.hidden) return;
        video.muted = true;
        video.play().catch(() => {
          if (!controller.signal.aborted && video.paused) {
            video.parentElement.classList.remove('is-playing');
          }
        });
      };
      const activate = (index) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          if (i !== index) panels[i].querySelectorAll('video').forEach(video => video.pause());
        });
        if (panels[index]) startVideo(panels[index]);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); activate(next); tabs[next].focus();
        }, options);
      });
      panels.forEach(panel => {
        const video = panel.querySelector('video');
        const play = panel.querySelector('.wb-adventure__play');
        if (video) {
          video.addEventListener('playing', () => {
            if (panel.hidden) { video.pause(); return; }
            video.parentElement.classList.add('is-playing');
          }, options);
          if (play) play.addEventListener('click', () => startVideo(panel), options);
        }
        const gallery = panel.querySelector('.wb-adventure__gallery');
        const tiles = [...gallery.children];
        tiles.forEach(tile => {
          const setFlipped = flipped => {
            tile.classList.toggle('is-flipped', flipped);
            tile.querySelector('.wb-adventure__face--front')?.setAttribute('aria-hidden', String(flipped));
            tile.querySelector('.wb-adventure__face--back')?.setAttribute('aria-hidden', String(!flipped));
          };
          const hoverEnabled = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
          tile.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && hoverEnabled()) setFlipped(true);
          }, options);
          tile.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse') setFlipped(false);
          }, options);
        });
        const pagination = panel.querySelector('.wb-adventure__pagination');
        let current = 0;
        const update = () => {
          pagination.hidden = tiles.length < 2;
          pagination.style.display = tiles.length < 2 ? 'none' : '';
          pagination.querySelector('[data-direction="-1"]').disabled = current === 0;
          pagination.querySelector('[data-direction="1"]').disabled = current === tiles.length - 1;
        };
        pagination.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
          current = Math.max(0, Math.min(tiles.length - 1, current + Number(button.dataset.direction)));
          tiles.forEach((tile, index) => { tile.style.setProperty('--adventure-tile-order', (index - current + tiles.length) % tiles.length); });
          gallery.scrollLeft = 0;
          update();
        }, options));
        update();
      });
      activate(Math.max(0, tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
      document.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index !== -1) activate(index);
      }, options);
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
